var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"white--text"},[_vm._v("CÓDIGOS UPC")]),_c('div',{staticClass:"mt-12"},[_c('app-register-user-form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }